// store/store.ts
import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import adminReducer from "./slices/adminSlice";
import authReducer from "./slices/authSlice";
import onboardReducer from "./slices/onboardingSlice";
import b2cAdminReducer from "./slices/b2c/b2cAdminSlice";

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    auth:authReducer,
    onboard:onboardReducer,
    b2cAdmin:b2cAdminReducer,
  },
});

// Types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed Hooks
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
